import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { postMethod, fetchAcademicListData } from "../service/api";
import {
  fetchSchoolLogos,
  fetchAllSchoolLogos,
  postAplicationFormReq,
  postAplicationFormReq1,
  postAplicationFormReq2,
  postAplicationFormReq3,
  postContactusForm,
} from "@/parentService/parentApi";
import { putRequest } from "@/parentService/putTestResults";

export const postEnquireForm: any = createAsyncThunk(
  "data/postEnquireForm",
  async (formData, { dispatch }) => {
    try {
      dispatch(setLoader(true));
      let data = await postMethod(`/api/v2/leads/createlead`, formData);
      setTimeout(() => {
        dispatch(setIsEmailExist(data?.data?.[0]?.status));
      }, 3000);
      dispatch(setLoader(false));
      return data;
    } catch (error) {
      dispatch(setLoader(false));
      dispatch(setIsEmailExist("failure"));
      throw error;
    }
  }
);

export const getAcademicData: any = createAsyncThunk(
  "data/getAcademicData",
  async (id, { dispatch }) => {
    try {
      dispatch(setLoader(true));
      let data = await fetchAcademicListData(`${id}`);
      // dispatch(setAcademicList(data?.data));
      dispatch(setLoader(false));
      return data;
    } catch (error) {
      dispatch(setLoader(false));
      throw error;
    }
  }
);

export const postStudentDetailsForm: any = createAsyncThunk(
  "data/postStudentDetailsForm",
  async (formData, { dispatch }) => {
    try {
      dispatch(setLoader(true));
      let data = await postAplicationFormReq(`/student-details`, formData);

      dispatch(setStudentDetailsInfo(data));
      dispatch(setLoader(false));
      return data;
    } catch (error) {
      dispatch(setLoader(false));
      throw error;
    }
  }
);

export const postFamilyDetailsForm: any = createAsyncThunk(
  "data/postFamilyDetailsForm",
  async (formData, { dispatch }) => {
    try {
      dispatch(setLoader(true));
      let data = await postAplicationFormReq1(`/family-details`, formData);

      dispatch(setStudentDetailsInfo(data));
      dispatch(setLoader(false));
      return data;
    } catch (error) {
      dispatch(setLoader(false));
      throw error;
    }
  }
);

export const postHighSchoolForm: any = createAsyncThunk(
  "data/postHighSchoolForm",
  async (formData, { dispatch }) => {
    try {
      let data = await postAplicationFormReq2(
        `/past/high-school/details`,
        formData
      );

      return data;
    } catch (error) {
      console.log("✌️error --->", error);
    }
  }
);

export const postTestResults: any = createAsyncThunk(
  "data/postTestResults",
  async (formData, { dispatch }) => {
    try {
      dispatch(setLoader(true));
      let data = await postAplicationFormReq3(`/student-test`, formData);

      dispatch(setTestResultsInfo(data));
      dispatch(setLoader(false));
      return data;
    } catch (error) {
      dispatch(setLoader(false));
      throw error;
    }
  }
);

export const putTestResultFileUpload: any = createAsyncThunk(
  "data/putTestResultFileUpload",
  async ({ url, formData }: any, { dispatch }) => {
    try {
      dispatch(setLoader(true));
      let data = await putRequest(`${url}`, formData);

      dispatch(setTestResultsInfo(data));
      dispatch(setLoader(false));
      return data;
    } catch (error) {
      dispatch(setLoader(false));
      throw error;
    }
  }
);

export const getSchoolLogo: any = createAsyncThunk(
  "data/getSchoolLogo",
  async (schoolName, { dispatch }) => {
    try {
      dispatch(setLoader(true));
      let { data } = await fetchSchoolLogos(`/school-logos`, schoolName);

      dispatch(setLoader(false));
      return data;
    } catch (error) {
      dispatch(setLoader(false));
      throw error;
    }
  }
);

export const getAllSchoolLogo: any = createAsyncThunk(
  "data/getAllSchoolLogo",
  async () => {
    try {
      let data = await fetchAllSchoolLogos(`/v2/school-logos-list`);
      return data;
    } catch (error) {
      throw error;
    }
  }
);

export const postAcademicForm: any = createAsyncThunk(
  "data/postAcademicForm",
  async (formData, { dispatch }) => {
    try {
      dispatch(setLoader(true));
      let { data } = await postAplicationFormReq2(
        `/submit/academic-details`,
        formData
      );
      // dispatch(setPostAcademicInfo(data?.data?.data))
      dispatch(setLoader(false));
      return data;
    } catch (error) {
      dispatch(setLoader(false));
      throw error;
    }
  }
);

export const postProfileForm: any = createAsyncThunk(
  "data/postProfileForm",
  async (formData, { dispatch }) => {
    try {
      dispatch(setLoader(true));
      let data = await postContactusForm(`/parent/profile`, formData);
      dispatch(setLoader(false));
      return data;
    } catch (error) {
      throw error;
    } finally {
      dispatch(setLoader(false));
    }
  }
);

export const updateStudentName: any = createAsyncThunk(
  "data/updateStudentName",
  async (formData, { dispatch }) => {
    try {
      dispatch(setLoader(true));
      let { data } = await postAplicationFormReq2(
        `/edit/studentinfo`,
        formData
      );
      dispatch(setLoader(false));
      return data;
    } catch (error) {
      dispatch(setLoader(false));
      throw error;
    }
  }
);

interface ForgeRockAuthInfo {
  userEmail?: any;
  userPassword?: any;
  getToken?: any;
  responsePayload?: any;
  givenName?: any;
  familyName?: any;
  educationId?: any;
}

interface initialStateType {
  homeData: any;
  privacyPolicyData: any;
  data: any;
  pageSearchData: any;
  isMobileDevice: boolean;
  loader: boolean;
  isEmailExist: string;
  headerData: any;
  isFooter: any;
  parentHeaderAndFooterData: any;
  parentHeaderAndFooterLoggedOutData: any;
  dashboardCmsData: any;
  parentLoginCmsData: any;
  parentContactusCmsData: any;
  parentOtpCmsData: any;
  isPageSearch: any;
  countryList: any;
  curriculumList: any;
  ratingList: any;
  schoolgradeList: any;
  schoolyearList: any;
  ids: string;
  expirationTime: any;
  isSticky: boolean;
  ages: any;
  applicationLabel: any;
  picklist: any;
  schoolList: any;
  academicList: any;
  // selectedOption:string;
  parentPrivacyPolicyData: any;
  parentTermsAndConditionData: any;
  ContactUs: any;
  studentDetailsInfo: any;
  familyDetailsInfo: any;
  settingsFormInfo: any;
  changePasswordLabel: any;
  createServiceReqInfo: any;
  highSchoolInfo: any;
  testResultsInfo: any;
  uploadUrl: any;
  testFileUpload: any;
  parentDashboardInfo: any;
  parentPageNotFound: any;
  parentProfileLabel: any;
  schoolLogo: any;
  schoolLogosList: any;
  postAcademicInfo: any;
  forgeRockUserDetails: any;
  forgeRockAuthInfo: ForgeRockAuthInfo | null;
  forgeRockToken: any;
  currentPage: any;
  ApplicationId: any;
  userLoggedinId: string;
  editApplicationData: any;
  appStatusData: any;
  schoolName: any;
  currentStep: number;
  existingStudentList:any;
  existingFatherId:string;
  existingMotherId:string;
}

const initialState: initialStateType = {
  homeData: [],
  privacyPolicyData: [],
  data: [],
  pageSearchData: [],
  isMobileDevice: false,
  loader: false,
  isEmailExist: "",
  headerData: null,
  isFooter: null,
  parentHeaderAndFooterData: null,
  parentHeaderAndFooterLoggedOutData: null,
  dashboardCmsData: null,
  parentLoginCmsData: null,
  parentContactusCmsData: null,
  parentOtpCmsData: null,
  isPageSearch: null,
  countryList: null,
  curriculumList: null,
  ratingList: null,
  schoolgradeList: null,
  schoolyearList: null,
  ids: "",
  expirationTime: null,
  isSticky: false,
  ages: null,
  applicationLabel: null,
  picklist: null,
  schoolList: null,
  academicList: null,
  // selectedOption:""
  parentPrivacyPolicyData: [],
  parentTermsAndConditionData: [],
  ContactUs: null,
  studentDetailsInfo: null,
  familyDetailsInfo: null,
  settingsFormInfo: null,
  changePasswordLabel: null,
  createServiceReqInfo: null,
  highSchoolInfo: null,
  testResultsInfo: null,
  uploadUrl: [],
  testFileUpload: null,
  parentDashboardInfo: null,
  parentPageNotFound: null,
  parentProfileLabel: null,
  schoolLogo: null,
  schoolLogosList: [],
  postAcademicInfo: null,
  forgeRockUserDetails: [],
  forgeRockAuthInfo: null,
  forgeRockToken: null,
  currentPage: null,
  ApplicationId: null,
  userLoggedinId: null,
  editApplicationData: null,
  appStatusData: null,
  schoolName: null,
  currentStep:0,
  existingStudentList:[],
  existingFatherId:null,
  existingMotherId:null,
};

export const dataSlice = createSlice({
  name: "data",
  initialState,
  reducers: {

    clearData: () => initialState,

    fetchHomeDataPage: (state: initialStateType, action) => {
      state.homeData = action.payload;
    },

    fetchPrivacyPolicyDataPage: (state: initialStateType, action) => {
      state.privacyPolicyData = action.payload;
    },

    fetchDataBritishCurriculumPage: (state: any, action) => {
      state.britishCurriculumData = action.payload;
    },

    fetchDataBritishCurriculumPageSchool: (state: any, action) => {
      state.britishCurriculumSchoolData = action.payload;
    },

    fetchDataSuccess: (state: initialStateType, action) => {
      state.data = action.payload;
    },

    fetchPageSearchData: (state: initialStateType, action) => {
      state.pageSearchData = action.payload;
    },

    setIsMobileDevice: (state: initialStateType, action) => {
      state.isMobileDevice = action.payload;
    },
    setLoader: (state: initialStateType, action) => {
      state.loader = action.payload;
    },
    setIsEmailExist: (state: initialStateType, action) => {
      state.isEmailExist = action.payload;
    },
    setHeaderData: (state: initialStateType, action) => {
      state.headerData = action.payload;
    },
    setFooter: (state: initialStateType, action) => {
      state.isFooter = action.payload;
    },
    setPageSearch: (state: initialStateType, action) => {
      state.isPageSearch = action.payload;
    },
    setCountryList: (state: initialStateType, action) => {
      state.countryList = action.payload;
    },
    setCurriculumList: (state: initialStateType, action) => {
      state.curriculumList = action.payload;
    },
    setRatingList: (state: initialStateType, action) => {
      state.ratingList = action.payload;
    },
    setSchoolgradeList: (state: initialStateType, action) => {
      state.schoolgradeList = action.payload;
    },
    setSchoolyearList: (state: initialStateType, action) => {
      state.schoolyearList = action.payload;
    },
    setIds: (state: initialStateType, action) => {
      state.ids = action.payload;
    },
    setExpirationTime: (state: initialStateType) => {
      state.expirationTime = Date.now() + 3600000; // Set expiration time to 1 hour from now
    },
    setIsSticky: (state: initialStateType, action) => {
      state.isSticky = action.payload;
    },
    setAges: (state: initialStateType, action) => {
      state.ages = action.payload;
    },
    setApplicationLabel: (state: initialStateType, action) => {
      state.applicationLabel = action.payload;
    },
    setPicklist: (state: initialStateType, action) => {
      state.picklist = action.payload;
    },
    setSchoolList: (state: initialStateType, action) => {
      state.schoolList = action.payload;
    },
    setAcademicList: (state: initialStateType, action) => {
      state.academicList = action.payload;
    },
    // setSelectedOption: (state:initialStateType,action) => {
    //   state.selectedOption = action.payload;
    // },
    setParentHeaderAndFooterData: (state: initialStateType, action) => {
      state.parentHeaderAndFooterData = action.payload;
    },

    setParentHeaderAndFooterDataLoggedOut: (
      state: initialStateType,
      action
    ) => {
      state.parentHeaderAndFooterLoggedOutData = action.payload;
    },

    setDashboardCmsData: (state: initialStateType, action) => {
      state.dashboardCmsData = action.payload;
    },

    setParentLoginCmsData: (state: initialStateType, action) => {
      state.parentLoginCmsData = action.payload;
    },

    setParentContactusCmsData: (state: initialStateType, action) => {
      state.parentContactusCmsData = action.payload;
    },

    setParentOtpCmsData: (state: initialStateType, action) => {
      state.parentOtpCmsData = action.payload;
    },

    fetchParentPrivacyPolicyData: (state: initialStateType, action) => {
      state.parentPrivacyPolicyData = action.payload;
    },
    fetchParentTermsAndConditionData: (state: initialStateType, action) => {
      state.parentTermsAndConditionData = action.payload;
    },
    setContactUs: (state: initialStateType, action) => {
      state.ContactUs = action.payload;
    },
    setStudentDetailsInfo: (state: initialStateType, action) => {
      state.studentDetailsInfo = action.payload;
    },
    setFamilyDetailsInfo: (state: initialStateType, action) => {
      state.familyDetailsInfo = action.payload;
    },
    setSettingsFormInfo: (state: initialStateType, action) => {
      state.settingsFormInfo = action.payload;
    },
    setChangePasswordLabel: (state: initialStateType, action) => {
      state.changePasswordLabel = action.payload;
    },
    setCreateServiceReqInfo: (state: initialStateType, action) => {
      state.createServiceReqInfo = action.payload;
    },
    setHighSchoolInfo: (state: initialStateType, action) => {
      state.highSchoolInfo = action.payload;
    },
    setTestResultsInfo: (state: initialStateType, action) => {
      state.testResultsInfo = action.payload;
    },
    setUploadUrl: (state: initialStateType, action) => {
      state.uploadUrl = action.payload;
    },
    setTestFileUpload: (state: initialStateType, action) => {
      state.testFileUpload = action.payload;
    },

    setParentDashboardInfo: (state: initialStateType, action) => {
      state.parentDashboardInfo = action.payload;
    },
    setParentPageNotFound: (state: initialStateType, action) => {
      state.parentPageNotFound = action.payload;
    },
    setParentProfileLabel: (state: initialStateType, action) => {
      state.parentProfileLabel = action.payload;
    },
    setSchoolLogo: (state: initialStateType, action) => {
      state.schoolLogo = action.payload;
    },
    setSchoolLogosList: (state: initialStateType, action) => {
      state.schoolLogosList = action.payload;
    },
    setPostAcademicInfo: (state: initialStateType, action) => {
      state.postAcademicInfo = action.payload;
    },

    setForgeRockUserDetails: (state: initialStateType, action) => {
      state.forgeRockUserDetails = action.payload;
    },

    // setForgeRockAuthInfo: (state:initialStateType, action) => {
    //   state.forgeRockAuthInfo = action.payload;
    // },

    setForgeRockAuthInfo: (state, action: { payload: ForgeRockAuthInfo }) => {
      state.forgeRockAuthInfo = action.payload;
    },

    setForgeRockToken: (state: initialStateType, action) => {
      state.forgeRockToken = action.payload;
    },

    // setForgeRockAuthInfo: (state, action: { payload: Partial<ForgeRockAuthInfo> }) => {
    //   state.forgeRockAuthInfo = {
    //     ...state.forgeRockAuthInfo, // Preserve existing fields
    //     ...action.payload, // Overwrite only the fields provided in the payload
    //   };
    // },

    clearForgeRockAuthInfo: (state) => {
      state.forgeRockAuthInfo = null;
      state.forgeRockToken = null;
    },

    setCurrentPage: (state: initialStateType, action) => {
      state.currentPage = action.payload;
    },
    setApplicationId: (state: initialStateType, action) => {
      state.ApplicationId = action.payload;
    },
    setUserLoggedinId: (state: initialStateType, action) => {
      state.userLoggedinId = action.payload;
    },
    setEditApplicationData: (state: initialStateType, action) => {
      state.editApplicationData = action.payload;
    },
    setAppStatusData: (state: initialStateType, action) => {
      state.appStatusData = action.payload;
    },
    setSchoolName: (state: initialStateType, action) => {
      state.schoolName = action.payload;
    },
    setCurrentStep: (state: initialStateType, action) => {
      state.currentStep = action.payload;
    },
    setExistingStudentList: (state: initialStateType, action) => {
      state.existingStudentList = action.payload;
    },
    setExistingFatherId: (state: initialStateType, action) => {
      state.existingFatherId = action.payload;
    },
    setExistingMotherId: (state: initialStateType, action) => {
      state.existingMotherId = action.payload;
    },

    resetState: () => initialState,
  },  
});

export const {
  clearData,
  fetchHomeDataPage,
  fetchPrivacyPolicyDataPage,
  fetchDataBritishCurriculumPage,
  fetchDataBritishCurriculumPageSchool,
  fetchDataSuccess,
  fetchPageSearchData,
  setIsMobileDevice,
  setLoader,
  setIsEmailExist,
  setHeaderData,
  setFooter,
  setPageSearch,
  setCountryList,
  setCurriculumList,
  setRatingList,
  setSchoolgradeList,
  setSchoolyearList,
  setIds,
  setExpirationTime,
  resetState,
  setIsSticky,
  setAges,
  setApplicationLabel,
  setPicklist,
  setSchoolList,
  setAcademicList,
  // setSelectedOption
  setParentHeaderAndFooterData,
  setParentHeaderAndFooterDataLoggedOut,
  setDashboardCmsData,
  setParentLoginCmsData,
  setParentContactusCmsData,
  setParentOtpCmsData,
  fetchParentPrivacyPolicyData,
  fetchParentTermsAndConditionData,
  setContactUs,
  setStudentDetailsInfo,
  setFamilyDetailsInfo,
  setSettingsFormInfo,
  setChangePasswordLabel,
  setCreateServiceReqInfo,
  setHighSchoolInfo,
  setTestResultsInfo,
  setUploadUrl,
  setTestFileUpload,
  setParentDashboardInfo,
  setParentPageNotFound,
  setParentProfileLabel,
  setSchoolLogo,
  setSchoolLogosList,
  setPostAcademicInfo,
  setForgeRockUserDetails,
  setForgeRockAuthInfo,
  setForgeRockToken,
  clearForgeRockAuthInfo,
  setCurrentPage,
  setApplicationId,
  setUserLoggedinId,
  setEditApplicationData,
  setAppStatusData,
  setSchoolName,
  setCurrentStep,
  setExistingStudentList,
  setExistingFatherId,
  setExistingMotherId
} = dataSlice.actions;

export const selectHomeData: any = (state: any) => state.data.homeData;
export const selectPrivacyPolicyData: any = (state: any) =>
  state.data.privacyPolicyData;
export const selectData: any = (state: any) => state?.data?.data;
export const selectPageSearchData: any = (state: any) =>
  state.data.pageSearchData;
export const selectDataBritishCurriculum: any = (state: any) =>
  state.data.britishCurriculumData;
export const selectDataBritishCurriculumSchool: any = (state: any) =>
  state.data.britishCurriculumSchoolData;
export const selectParentHeaderAndFooterData: any = (state: any) =>
  state.data.parentHeaderAndFooterData;
export const selectParentHeaderAndFooterLoggedOutData: any = (state: any) =>
  state.data.parentHeaderAndFooterLoggedOutData;
export const selectDashboardCmsData: any = (state: any) =>
  state.data.dashboardCmsData;
export const selectParentLoginCmsData: any = (state: any) =>
  state.data.parentLoginCmsData;
export const selectParentContactusCmsData: any = (state: any) =>
  state.data.parentContactusCmsData;
export const selectParentOtpCmsData: any = (state: any) =>
  state.data.parentOtpCmsData;

export const selectParentPrivacyPolicyData: any = (state: any) =>
  state.data.parentPrivacyPolicyData;
export const selectParentTermsAndConditionData: any = (state: any) =>
  state.data.parentTermsAndConditionData;

export const getForgeRockUserDetails: any = (state: any) =>
  state.data.forgeRockUserDetails;
export const getForgeRockAuthInfo = (state: any): ForgeRockAuthInfo | null =>
  state.data.forgeRockAuthInfo;

export const getForgeRockToken: any = (state: any) => state.data.forgeRockToken;

export const getCurrentPage: any = (state: any) => state.data.currentPage;

export default dataSlice.reducer;
